"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const tslib_1 = require("tslib");
const color_1 = tslib_1.__importDefault(require("./tokens/color"));
const font_1 = tslib_1.__importDefault(require("./tokens/font"));
const globals_1 = require("./tokens/globals");
const palette_1 = tslib_1.__importDefault(require("./tokens/palette"));
const radius_1 = tslib_1.__importDefault(require("./tokens/radius"));
const shadow_1 = tslib_1.__importDefault(require("./tokens/shadow"));
const spacing_1 = tslib_1.__importDefault(require("./tokens/spacing"));
exports.theme = {
    radius: radius_1.default,
    font: font_1.default,
    spacing: spacing_1.default,
    palette: palette_1.default,
    shadow: shadow_1.default,
    globals: globals_1.globals,
    // ! need to deprecate
    color: color_1.default,
};
//# sourceMappingURL=default.theme.js.map